import './BetbookMatchExpiration.less';

import clsx from 'clsx';
import moment from 'moment';
import React from 'react';

import i18n from '../../common/i18n';
import { SportIconNui } from '../../icons/SportIconNui';

function BetbookMatchExpiration({ tournament, matchExpirationDate, otherClassNames, sportId }) {
    const startOfToday = moment().startOf('day');
    const endOfToday = moment().endOf('day');
    const endOfTomorrow = moment()
        .add(1, 'days')
        .endOf('day');
    const matchStart = moment(matchExpirationDate);
    const expirationTime = matchStart.format('HH:mm');
    const expirationDate = matchStart.format('DD.MM.YYYY - HH:mm');
    const isPlayingToday = matchStart.isBetween(startOfToday, endOfToday);
    const isPlayingTomorrow = matchStart.isBetween(endOfToday, endOfTomorrow);
    const isPlayingLater = matchStart.isAfter(endOfTomorrow);
    const wasPlaying = matchStart.isBefore(startOfToday);

    return (
        <div className={clsx('fs-12 p-rel flex items-center', otherClassNames)}>
            {sportId ? (
                <div className="mr-10 fs-0">
                    <SportIconNui sportId={sportId} className={'icon-grey'} />
                </div>
            ) : null}
            <span className="betbook-match-title betbook-match-title-br uppercase br-radius-2 mr-10">{tournament}</span>
            <span
                className={clsx('uppercase br-radius-2', {
                    'betbook-match-expiration-date br-default bg-black-20': isPlayingToday || isPlayingTomorrow,
                    'betbook-match-title betbook-match-title-br': isPlayingLater || wasPlaying
                })}
            >
                {isPlayingToday
                    ? i18n('betbook.analysis.expiration.today') + ' ' + expirationTime
                    : isPlayingTomorrow
                    ? i18n('betbook.analysis.expiration.tomorrow') + ' ' + expirationTime
                    : expirationDate}
            </span>
        </div>
    );
}

export default BetbookMatchExpiration;
